var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"form-label"},[_c('span',{staticClass:"required-label",class:{required: _vm.required}},[_vm._v(_vm._s(_vm.required ? '必須' : '任意'))]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }